// Apple Services ID (NOT the iOS Bundle ID). Must match what's configured
// on developer.apple.com → Identifiers → Services IDs.
export const APPLE_CLIENT_ID = "com.deeclass.signin.web";

// Return URL registered on the Services ID. Apple requires HTTPS and will
// NOT accept localhost — for dev, register an ngrok/cloudflared tunnel on
// developer.apple.com alongside production.
export const APPLE_REDIRECT_URI = "https://deeclass.com/auth/apple/callback";
